export const InstructionPanel: React.FC<{ children?: React.ReactNode }> = ({ children }) => (
  <div className="rounded-md border bg-[#F9F9F9] px-4 py-3 shadow-sm">{children}</div>
)
